import BlogComponent from "./BlogComponent";
export default BlogComponent;
